import { createI18n } from "vue-i18n";
const folderReader = require.context("./lang", true, /\.ts$/);
const [
  Arabic,
  Chinese,
  Chinese_yy,
  English,
  French,
  German,
  Italian,
  Japanese,
  Korean,
  Portuguese,
  Russian,
  Spanish,
  Turkish,
] = folderReader.keys().map((k) => {
  return folderReader(k).default;
});

const i18n = createI18n({
  locale: "English", // 设置默认语言
  legacy: false,
  messages: {
    Arabic,
    Chinese,
    Chinese_yy,
    English,
    French,
    German,
    Italian,
    Japanese,
    Korean,
    Portuguese,
    Russian,
    Spanish,
    Turkish,
    Cantonese: Chinese_yy,
  },
});

export default i18n;
